import {useNavigate} from "react-router-dom";

import {SectionCardHeaderAction, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";
import EditIcon from "@mui/icons-material/Edit";
import {NumberUtil} from "base/utilities";
import {SisbagalSectionCard} from "sisbagal/auth";

const EDARXestionLodosAlleosSection = ({edar}) => {
    const navigate = useNavigate();

    const secondaryActions = [
        <SectionCardHeaderAction
            key="edit"
            name="edit"
            text="Modificar"
            icon={<EditIcon />}
            onClick={() => {
                navigate(`xestionlodosalleos/edit`);
            }}
            roles={[]}
        />,
    ];

    return (
        <SisbagalSectionCard title="Xestión lodos" secondaryActions={secondaryActions}>
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Tratamento de lodos alleos:"
                        value={edar.lodos_orixe_label}
                        tooltipText="Recíbense lodos procedentes de outros sistemas ou instalacións?"
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Cantidade lodos alleos:"
                        value={NumberUtil.formatDecimal(edar.lodos_cantidade_alleo)}
                        tooltipText="Cantidade de lodos alleos recibidos"
                        unit="t/ano"
                    />
                </Grid>
            </Grid>
        </SisbagalSectionCard>
    );
};

export default EDARXestionLodosAlleosSection;
